import type { VPAuthConfig } from '@vp/ubik-context';

export const createAuthConfig = (culture: string): VPAuthConfig => ({
  culture,
  options: {
    requireSession: true,
  },
});

export const aggregateNRCommonData = (
  profile: Record<string, string | undefined> | undefined
) => {
  let canonicalId: string | undefined;
  let isAnonymousUser = false;
  let isInternalUser = false;
  if (profile) {
    canonicalId = profile['https://claims.cimpress.io/canonical_id'];

    // anonymous user
    if (profile['https://claims.cimpress.io/is_anonymous']) {
      isAnonymousUser = true;
    }

    // internal user
    if (profile['https://claims.cimpress.io/cimpress_internal']) {
      isInternalUser = true;
    }
  }

  return { canonicalId, isAnonymousUser, isInternalUser };
};
